import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  public constructor(private readonly userService: UserService) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    var currentUser = this.userService.getCurrentUser();
    if (currentUser == null) {
      window.location.href = "/identity/account/login?returnUrl=" + state.url;
      return of(false);
    } else if (!currentUser.permissions.includes(route.data.permission)) {
      window.location.href = "/identity/account/accessdenied";
      return of(false);
    }
    return of(true);
  }
}
